export const ExperienceKeyMetricDtoDescriptions = {
  id: "Server-generated. Read-only.",
  experienceId: "References the parent experience.",
  order: "Display position in the analytics dashboard. 0-indexed.",
  isPrimary:
    "The primary metric determines the main success signal for the test. Exactly one per experience.",
  standardEventId:
    "Standard e-commerce event (e.g., revenue, conversion). Mutually exclusive with experienceCustomMetricId.",
  experienceCustomMetricId:
    "References a custom event metric. Mutually exclusive with standardEventId. Exactly one of these must be set.",
} as const;

export const CreateExperienceKeyMetricDtoDescriptions = {
  id: "Omit to auto-generate.",
  experienceId:
    "Omit when creating as part of a new experience -- auto-assigned from parent.",
  order:
    "Display order in analytics. Must be unique across metrics. 0-indexed.",
  isPrimary: "Exactly one metric per experience must be primary.",
  standardEventId:
    "Standard e-commerce event to track. Mutually exclusive with experienceCustomMetricId -- set exactly one.",
  experienceCustomMetricId:
    "References a custom metric. Mutually exclusive with standardEventId -- set exactly one.",
} as const;

export const ExternalExperienceKeyMetricDescriptions = {
  id: "Copy from GET response to preserve an existing key metric. Omit when adding a new key metric -- an id is generated automatically.",
  customEventId:
    "Attach an existing custom event (from list_custom_events / create_or_update_custom_event) as this key metric. The per-experience custom-metric join row is created automatically. Mutually exclusive with standardEventId and experienceCustomMetricId -- set exactly one of the three. To keep referencing an already-attached custom metric on update, pass back its experienceCustomMetricId instead (from the prior response or get_experience) -- no need to resend customEventId.",
} as const;
